<div class="cart-indicator">
  <div class="row justify-content-center d-none d-lg-flex pb-2rem">
    <div class="col-lg-7 col-md-10 col-sm-11">
      <div class="horizontal-steps pb-2rem">
        <div class="horizontal-steps-content">
          @for (step of shoppingCartSteps; track step) {
            <div [id]="'step-' + step.number" class="step-item"
              [ngClass]="{ 'active': activeStep === step.number, 'done': step.number <= finishedStep }">
              @if (step.number > finishedStep) {
                <span class="content font-12">
                  {{ step.number }}
                </span>
              }
              @if (step.number <= finishedStep) {
                <span class="content font-12">
                  <i class="dripicons-checkmark"></i>
                </span>
              }
              <span class="font-14">{{ step.titleKey | translate }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="active-step-sm mb-2rem font-20 d-lg-none color-gray">
    {{ shoppingCartSteps[activeStep - 1].titleKey | translate }}
  </div>
</div>
